module.exports = "/_next/static/images/71bb20640ad5bf2bc8b357f5878133e3-pj-man-holding-business-card@0.5x.jpg.webp";